import React from 'react';
import 'styles/components/common/Footer.scss';
import { NavLink } from 'react-router-dom';
import menuItems from 'assets/data/menuItems.json';

const Footer = () => {

    return (
        <section className='Footer'>
            <div className="footer-wrapper">
                <div className='top'>
                    <div className='logo' />
                    <div className='menu-items'>
                        {menuItems.map(menu => <div className='menu-item' key={menu.id}>
                            <NavLink key={menu.id} to={`${menu.link}`}>
                                {menu.name}
                            </NavLink>
                        </div>)}
                    </div>
                </div>
                <div className='divisionLine' />
                <div className='bottom'>
                    <span className='sp_r07'>어질인소프트(주)</span><br className='lineBreak p' />
                    <span className='sp_r07'>주소 : <span className='fw_normal sp_r07'>대전광역시 대덕구 대화로 106번길 66, 1002호</span><br className='lineBreak address' /><span className='fw_normal sp_r07'>(대화동, 펜타플렉스), 34365</span></span><br className='lineBreak p' />
                    <span className='sp_r07'>대표번호 : <span className='fw_normal sp_r07'>042-472-2094</span> 팩스 : <span className='fw_normal'>042-472-2097</span><br className='lineBreak' /></span>
                    <span className='sp_r07'>이메일 : <span className='fw_normal sp_r07'>master@agilinsoft.com</span> 대표이사 : <span className='fw_normal'>차문종</span><br className='lineBreak p' /></span>
                    <span className='fw_normal sp_r07'>Copyright © 2023 Agilinsoft Inc. All Rights Reserved. </span>
                </div>
            </div>
        </section >
    );
};

export default React.memo(Footer);